import { type AxiosError, HttpStatusCode } from "axios";

import { cleanUpUserSession } from "@/utils";

export const errorResponseInterceptor = async (error: AxiosError) => {
  if (
    error.response &&
    error.response.status === HttpStatusCode.Unauthorized &&
    !error.config?.baseURL?.includes("/logout")
  ) {
    cleanUpUserSession();
    const { hash, pathname, search } = window.location;
    window.location.href = "/login?redirect=" + encodeURIComponent(pathname + search + hash);
  }

  return Promise.reject(error);
};
